(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alchemira-daily-rituals"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('alchemira-rituals')){
  customElements.define('alchemira-rituals',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.tabs=Array.from(this.querySelectorAll('[data-ritual-tab]'));
      this.panels=Array.from(this.querySelectorAll('[data-ritual-panel]'));
      this.addEventListener('click',e=>{const tab=e.target.closest('[data-ritual-tab]');if(tab)this.select(tab.dataset.ritualTab,false)});
      this.addEventListener('keydown',e=>{
        const tab=e.target.closest('[data-ritual-tab]');if(!tab)return;
        const i=this.tabs.indexOf(tab);let next;
        if(e.key==='ArrowRight'||e.key==='ArrowDown')next=(i+1)%this.tabs.length;
        if(e.key==='ArrowLeft'||e.key==='ArrowUp')next=(i-1+this.tabs.length)%this.tabs.length;
        if(e.key==='Home')next=0;if(e.key==='End')next=this.tabs.length-1;
        if(next!==undefined){e.preventDefault();this.select(this.tabs[next].dataset.ritualTab,true)}
      });
      this.addEventListener('shopify:block:select',e=>this.select(e.detail.blockId,false));
    }
    select(id,focus){
      if(!this.tabs.some(t=>t.dataset.ritualTab===id))return;
      this.tabs.forEach(t=>{const active=t.dataset.ritualTab===id;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;if(active&&focus)t.focus()});
      this.panels.forEach(p=>{p.hidden=p.dataset.ritualPanel!==id});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alchemira-press-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alchemira-press')) {
    customElements.define('alchemira-press',class extends HTMLElement {
      connectedCallback() {
        if(this.cleanup)return;
        const viewport=this.querySelector('.ap-window');
        const group=this.querySelector('.ap-group');
        const reduced=matchMedia('(prefers-reduced-motion: reduce)');
        let playing=this.dataset.autoplay==='true'&&!reduced.matches;
        let hovered=false,focused=false,raf,last=0,width=0;
        const pause=()=>{playing=false;};
        const enter=()=>{hovered=true;};
        const leave=()=>{hovered=false;};
        const focus=()=>{focused=true;};
        const blur=()=>{focused=false;};
        const motion=()=>{if(reduced.matches)pause();};
        const step=time=>{
          const delta=last?Math.min(time-last,64):0;last=time;
          if(playing&&!hovered&&!focused&&!document.hidden&&width>0){viewport.scrollLeft+=delta*Number(this.dataset.speed)/1000;if(viewport.scrollLeft>=width)viewport.scrollLeft-=width;}
          raf=requestAnimationFrame(step);
        };
        this.dataset.enhanced='true';
        const observer=new ResizeObserver(()=>{this.querySelectorAll('.ap-group').forEach(list=>{list.style.minWidth=viewport.clientWidth+'px';});width=group.getBoundingClientRect().width;});observer.observe(viewport);
        viewport.addEventListener('pointerenter',enter);viewport.addEventListener('pointerleave',leave);
        viewport.addEventListener('focusin',focus);viewport.addEventListener('focusout',blur);
        viewport.addEventListener('pointerdown',pause);viewport.addEventListener('wheel',pause,{passive:true});
        viewport.addEventListener('keydown',pause);reduced.addEventListener('change',motion);
        raf=requestAnimationFrame(step);
        this.cleanup=()=>{cancelAnimationFrame(raf);observer.disconnect();viewport.removeEventListener('pointerenter',enter);viewport.removeEventListener('pointerleave',leave);viewport.removeEventListener('focusin',focus);viewport.removeEventListener('focusout',blur);viewport.removeEventListener('pointerdown',pause);viewport.removeEventListener('wheel',pause);viewport.removeEventListener('keydown',pause);reduced.removeEventListener('change',motion);};
      }
      disconnectedCallback(){this.cleanup?.();this.cleanup=null;}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alchemira-site-footer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('alchemira-footer')){
  customElements.define('alchemira-footer',class extends HTMLElement{
    connectedCallback(){
      if(this.cleanup)return;
      const media=matchMedia('(max-width:749px)');
      const columns=[...this.querySelectorAll('.af-column')];
      const adapt=()=>columns.forEach(column=>{column.open=!media.matches||column.dataset.group==='uses';});
      const click=event=>{if(!media.matches&&event.target.closest('summary'))event.preventDefault();};
      adapt();media.addEventListener('change',adapt);this.addEventListener('click',click);
      this.cleanup=()=>{media.removeEventListener('change',adapt);this.removeEventListener('click',click);};
    }
    disconnectedCallback(){this.cleanup?.();this.cleanup=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
